import React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { assigneeColor, userLabel } from './taskOptions';

interface Props {
	user: { id: number; full_name: string | null; email: string } | null;
	/** Every possible assignee; their order fixes each person's colour. */
	assignees: { id: number }[];
}

function initials(user: { full_name: string | null; email: string }): string {
	if (user.full_name) {
		return user.full_name
			.split(/\s+/)
			.filter(Boolean)
			.slice(0, 2)
			.map((part) => part[0].toUpperCase())
			.join('');
	}
	return user.email.slice(0, 1).toUpperCase();
}

/** A person as a coloured initials circle plus their name. The colour follows the person everywhere tasks appear. */
export default function TaskAssigneeLabel({ user, assignees }: Props) {
	if (!user) {
		return null;
	}
	return (
		<Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
			<Avatar
				sx={{
					width: 24,
					height: 24,
					fontSize: 11,
					fontWeight: 600,
					bgcolor: assigneeColor(user.id, assignees),
					color: '#0b1220',
				}}
			>
				{initials(user)}
			</Avatar>
			<Typography variant="body2" noWrap>
				{userLabel(user)}
			</Typography>
		</Box>
	);
}
